import { render, staticRenderFns } from "./EditParcelItems.vue?vue&type=template&id=60f02d3c&"
import script from "./EditParcelItems.vue?vue&type=script&lang=js&"
export * from "./EditParcelItems.vue?vue&type=script&lang=js&"
import style0 from "./EditParcelItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports